import React, {useState} from "react";
import InputMask from 'react-input-mask';

export default props => {
    const [inputFocus, setInputFocus] = useState(false);
    
    const elementID = props.elementID ? props.elementID : Math.random();
    const labelID = props.labelID ? props.labelID : Math.random();
    const type = props.type ? props.type : "text";

    function handleBlur() {
        if (props.value == null || props.value.length === 0) {
            setInputFocus(false)
        } else {
            document.getElementById(`${labelID}`).classList.remove("blue");
        }
    }

    function handleFocus() {
        setInputFocus(true);
        document.getElementById(`${labelID}`).classList.add("blue");
    }

    return (
        <div className="group">
            <div id={labelID}
                 className={`label ${(inputFocus || props.value == null || props.value.length > 0) ? "focus " : "blur"}
                 ${inputFocus ? "blue" : ""}
                 ${props.hasError ? "error-label" : ""}`}
                 onClick={() => document.getElementById(`${elementID}`).focus()}> {props.label}
            </div>

            <InputMask mask={props.mask} readOnly={props.readOnly} id={elementID} name={props.name} type={type}
                   className={`form-control field 
                   ${props.hasError ? "error" : " "}`}
                   value={props.value} onChange={props.onChange} onFocus={handleFocus} onBlur={props.onBlur? props.onBlur: handleBlur }
                   onKeyPress={props.onKeyPress}
                   onKeyUp={props.onKeyUp}  />

            <span className={`span-display 
                   ${props.hasError ? "fail" : " "}`}>{props.hasError? props.error: " "}</span>

        </div>
    )
}
